<ng-container *transloco="let t">
  <a
    [routerLink]="isSuspended() ? null : ['/accounts', organization().id]"
    [queryParams]="orgQueryParams()"
    queryParamsHandling="replace"
    class="contents"
  >
    <td iTableTd class="max-w-0 truncate">
      <span class="truncate">{{ organization().organizationName }}</span>
    </td>
    <td iTableTd>
      @if (isSuspended()) {
        <span class="text-destructive text-xs">{{ t("suspension.access_suspended") }}</span>
      } @else {
        <span class="text-xs text-gray-500">
          {{ t("account-setting.n_account_groups", { count: accountGroupsLength() }) }} /
          {{ t("account-setting.n_accounts", { count: accountLength() }) }}
        </span>
      }
    </td>
    <td iTableTd>
      @if (organization().organization.defaultCampaignLabel) {
        <span class="text-sm text-gray-800">{{ organization().organization.defaultCampaignLabel }}</span>
      } @else {
        <span class="text-xs text-gray-500">-</span>
      }
    </td>
    <td iTableTd class="text-right">
      @if (isAdmin() && !isSuspended() && !productTour()) {
        <button
          iButton
          [iDropdownMenuTrigger]="rowMenu"
          color="gray"
          variant="ghost"
          size="sm"
          class="opacity-0 group-hover:opacity-100"
          placement="bottom-end"
          (click)="$event.preventDefault(); $event.stopPropagation()"
        >
          <IIcon name="ellipsis" />
        </button>

        <ng-template #rowMenu>
          <IDropdownMenu class="w-[230px]">
            <a iDropdownMenuItem [routerLink]="[organization().id, 'account-linking']" [queryParams]="orgQueryParams()">
              <IIcon name="add" />
              {{ t("account-setting.add_account") }}
            </a>
            <button iDropdownMenuItem (click)="openEditDefaultCampaignLabelModal()">
              <IIcon name="tag" />
              {{ t("account-setting.edit_default_campaign_label") }}
            </button>
          </IDropdownMenu>
        </ng-template>
      }
    </td>
  </a>
</ng-container>
